import { Component, Input, TemplateRef } from '@angular/core'
import { RootState } from '@helios/state-management'
import { Store } from '@ngrx/store'
import { distinctUntilChanged } from 'rxjs/operators'
import { getIsAggregateFocused } from '../content-predicate-streams'

@Component({
  selector: 'hs-no-focused-aggregate',
  styleUrls: ['no-focused-aggregate.component.scss'],
  templateUrl: 'no-focused-aggregate.component.html',
})
export class NoFocusedAggregateComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() content: TemplateRef<any> | null = null

  isAggregateFocused = getIsAggregateFocused(this.store).pipe(
    distinctUntilChanged(),
  )

  constructor(private readonly store: Store<RootState>) {}
}
